module.exports = __webpack_public_path__ + "static/media/sidemenu_logo.e43603ad.jpg";